import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth is cookie-based (httpOnly, secure, samesite=none) set by /api/auth/session.
// withCredentials ensures the cookie is sent on cross-origin requests.
export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

export const API_BASE = BASE;
